import { DirectoFormValues } from '../models/schema'
import { fromDirectoEventResponse, toDirectoEventCreate } from '../models/mapper'
import { DirectoEvent } from '../models/types'
import { createDirectoEventV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createDirectoEvent(transitOperationId: number, formValues: DirectoFormValues): Promise<DirectoEvent> {
  const response = await createDirectoEventV2(toDirectoEventCreate(transitOperationId, formValues))
  return fromDirectoEventResponse(response)
}
